<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10 15.5V8.5L16 12L10 15.5Z" fill="currentColor"/>
    <path v-else d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM10 8.5V15.5L16 12L10 8.5Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconContent",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
